import React, { FC, useState } from 'react';
import { TbClipboardCheck, TbClipboardCopy } from 'react-icons/tb';
import { useTheme } from '@material-ui/core';
import { useStyles } from './styles/globals';
import { copyDeviceAuthURL } from './utils/auth';

export interface AuthRequestProps {
  deviceAuthToken: string;
}

const AuthRequest: FC<AuthRequestProps> = ({ deviceAuthToken }) => {
  const theme = useTheme();
  const classes = useStyles();
  const [authLinkCopied, setAuthLinkCopied] = useState(false);

  return (
    <>
      <span className={classes.appTitle}>
        <a
          onClick={() => {
            copyDeviceAuthURL(deviceAuthToken);
            setAuthLinkCopied(true);
          }}
          style={{
            color: authLinkCopied ? theme.palette.primary.main : theme.palette.info.main,
            cursor: 'pointer',
          }}
        >
          Copy this link{' '}
          {authLinkCopied ? (
            <TbClipboardCheck size={24} color={theme.palette.primary.main} />
          ) : (
            <TbClipboardCopy size={24} color={theme.palette.info.main} />
          )}
        </a>{' '}
        and paste it into your browser to authenticate yourself &amp; view Talka-extracted insights
        in real-time!
      </span>
      <span className={classes.appText} style={{ color: theme.palette.text.secondary }}>
        The page will refresh when authentication is complete.
      </span>
    </>
  );
};

export default AuthRequest;
